import { apiClient } from '@app/api';
import { ButtonLinkExternal } from '@app/components/base/ButtonLinkExternal';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import React from 'react';
import { useIntl } from 'react-intl';

interface Props {
  platform: SocialPlatform;
  stationId: string;
  children?: React.ReactNode;
  loginSuffix?: string;
}

export const DefaultPlatformConnect = ({ platform, stationId, children, loginSuffix }: Props) => {
  const { $t } = useIntl();
  const connectUrl = apiClient.generateUrl(
    `/social-export/auth/${platform.id.toLowerCase()}/login${
      loginSuffix ? `-${loginSuffix}` : ''
    }?station=${stationId}`,
    { secure: true },
  );

  return (
    <ButtonLinkExternal
      to={connectUrl}
      variant="outlined"
      color="primary"
      startIcon={platform.Icon()}
    >
      {children ?? <>{$t({ id: 'socialExport.connect', defaultMessage: 'Conectar' })}</>}
    </ButtonLinkExternal>
  );
};
